module.exports = __webpack_public_path__ + "static/media/landpage3Desktop.df4b525c.png";